import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "@/config/auth";
import { App } from "./App";
// Initialise Application Insights as early as possible so that
// any errors thrown during bootstrap are also captured.
import "@/services/telemetry";
import "./locales/i18n";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);

// Handle redirect promise on load
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().catch(console.error);

  createRoot(document.getElementById("root")!).render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  );
});
